import type { ComponentProps } from 'react';

import * as uiLib from '@compliance.ai/web-components';
import * as elements from './elements';

export const useWorkflowTaskDetailsRightPanelConfig = (): Required<
  ComponentProps<typeof uiLib.AppNavigation>
>['rightPanelConfig'] => {
  return {
    tabs: [],
    isClosable: true,
    content: <elements.WorkflowTaskDetails />
  };
};
